import {FieldArray, Form, Formik} from "formik";
import {Button, Col, Row} from "reactstrap";
import AppFormLabel from "../../views/components/forms/AppFormLabel";
import AppTextInput from "../../views/components/forms/AppTextInput";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import AppButton from "../../views/components/Common/AppButton";
import React from "react";
import {DomainDto} from "../../types/apiTypes";

type DomainForLoopProps = {
    domains: DomainDto[]
    handleSubmit: (e) => void
    isSubmitting?: boolean
}

export default function DomainForLoop({domains, handleSubmit, isSubmitting}: DomainForLoopProps) {
    return <Formik
        enableReinitialize
        initialValues={{
            domains: domains?.map(domain => {
                return {
                    isStatic: domain.isStatic || false,
                    email: domain.name,
                }
            }) || []
        }}
        onSubmit={handleSubmit}
    >
        {({handleSubmit, values}) => {
            return <Form onSubmit={handleSubmit}>
                <FieldArray
                    name={'domains'}
                    render={arrayHelpers => {
                        return (
                            <Row>
                                <Col lg={12}>
                                    <AppFormLabel label={'Domain names'} required />
                                </Col>
                                {values?.domains?.map((domain, index) => {
                                    return (
                                        <Row className={'mb-2'}>
                                            <Col lg={domain.isStatic ? 12 : 11}>
                                                <AppTextInput
                                                    disabled={domain.isStatic}
                                                    name={`domains[${index}].email`}
                                                />
                                            </Col>

                                            <Col lg={1} className={'d-flex justify-content-end'}>
                                                {
                                                    !domain.isStatic && <Button
                                                        onClick={() => arrayHelpers.remove(index)}
                                                        size="md"
                                                        color="danger"
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} size="sm"/>
                                                    </Button>
                                                }
                                            </Col>
                                        </Row>
                                    )
                                })}

                                <Col lg={12} className={'mt-4 d-flex justify-content-end'}>
                                    <Button
                                        onClick={() => arrayHelpers.push({email: '', isStatic: false})}
                                        size="md"
                                        color="primary"
                                    >
                                        <FontAwesomeIcon icon={faPlus} size="sm" />
                                    </Button>
                                </Col>
                            </Row>
                        )
                    }}
                />
                <Row className='text-end mt-4'>
                    <Col>
                        <AppButton
                            loading={isSubmitting}
                            title={'Save'}
                            variant='save'
                            buttonSize='lg'
                            type='submit'
                        />
                    </Col>
                </Row>
            </Form>
        }}
    </Formik>
}